import React from 'react';
import {
  StyledTabularDataRow,
  StyledTabularTitle,
  StyledTabularValue,
} from '../../../../../components/styles/StyledTabular';
import { Position } from '../../../../../lib/modelBuilder/constants';
import { useTranslation } from 'react-i18next';
import { Rack } from '../../../../../lib/modelBuilder/entities/Rack';
import { CustomPiece } from '../../../../../lib/modelBuilder/pieces/CustomPiece';
import { Pane } from '../../../../../lib/modelBuilder/pieces/Pane';
// import styled from 'styled-components';

interface Props {
  title: string;
  rack: Rack;
  materialName: any;
}

const PlateDescription = ({ title, rack, materialName }: Props) => {
  const { t } = useTranslation();

  const getPlateDescription = (rack: Rack, position: Position) => {
    const plate: CustomPiece<Pane> | undefined = rack.plate;
    const glassPlate: CustomPiece<Pane> | undefined = rack.glassPlate;
    if (plate) {
      let description = '';
      if (glassPlate) {
        description += ` + ${t('double layer')} ${t('Glass')}`;
      }
      return `${materialName(plate.color.material)} ${
        plate.color.name
      }${description}`;
    } else return t('None');
  };

  return (
    <StyledTabularDataRow>
      <StyledTabularTitle>{title}</StyledTabularTitle>
      <StyledTabularValue>{`${getPlateDescription(
        rack,
        Position.Front,
      )}`}</StyledTabularValue>
    </StyledTabularDataRow>
  );
};

export default PlateDescription;
